export default "__VITE_ASSET__$2TTY4kA__"